/* Custom Icons */
import MenuHomeIcon from "components/icons/MenuHomeIcon"
import MenuHomeActiveIcon from "components/icons/MenuHomeActiveIcon"
import MenuAsistantIcon from "components/icons/MenuAsistantIcon"
import MenuAsistantActiveIcon from "components/icons/MenuAsistantActiveIcon"
import MenuDevelopmentIcon from "components/icons/MenuDevelopmentIcon"
import MenuDevelopmentActiveIcon from "components/icons/MenuDevelopmentActiveIcon"
import MenuPerformanceIcon from "components/icons/MenuPerformanceIcon"
import MenuPerformanceActiveIcon from "components/icons/MenuPerformanceActiveIcon"
import MenuCalendarIcon from "components/icons/MenuCalendarIcon"
import MenuCalendarActiveIcon from "components/icons/MenuCalendarActiveIcon"
import MenuSelf from "components/icons/MenuSelf"
import MenuSelfActive from "components/icons/MenuSelfActive"
import MenuLeaveRequestIcon from "components/icons/MenuLeaveRequestIcon"
import MenuLeaveRequestActiveIcon from "components/icons/MenuLeaveRequestActiveIcon"

/* Pages */
import ResetPasswordValidate from "pages/reset-password-validate"
import ResetPassword from "pages/reset-password"
import GoogleSuccess from "pages/google-success"
import VendorProposalSubmit from "pages/vendor-proposal"
import GoogleFail from "pages/google-fail"
import Home from "pages/home"
import Calendar from "pages/calendar"
import SignIn from "pages/sign-in"
import ChangePassword from "pages/change-password"
import Assistant from "pages/assistant"
import StudentDetail from "pages/student-detail"
import { Notification } from "pages/notifications"
import MyImpact from "pages/impact"
import PurchaseRequisitionContainer from "pages/procurement/PurchaseRequisitionContainer"
import CreateRequestContainer from "pages/procurement/CreateRequestContainer"
import RequestDetailContainer from "pages/procurement/RequestDetailContainer"
import BudgetOverviewContainer from "pages/procurement/BudgetOverviewContainer"
import SuppliersContainer from "pages/procurement/SuppliersContainer"
import SupplierDetailContainer from "pages/procurement/SupplierDetailContainer"
import OrdersContainer from "pages/procurement/OrdersContainer"
import PurchasesContainer from "pages/procurement/PurchasesContainer"
import CreatePurchaseContainer from "pages/procurement/CreatePurchaseContainer"
import PurchaseDetailContainer from "pages/procurement/PurchaseDetailContainer"
import ReportContainer from "pages/procurement/ReportContainer"
import BudgetReportContainer from "pages/procurement/BudgetReportContainer"
import OrderRequestContainer from "pages/procurement/OrderRequestContainer"
import OrderRequestFormContainer from "pages/procurement/OrderRequestFormContainer"
import VendorProposalsPageContainer from "pages/procurement/VendorProposalsPageContainer"
import GroupOrderFormContainer from "pages/procurement/GroupOrderFormContainer"
import GroupOrderDetailContainer from "pages/procurement/GroupOrderDetailContainer"
import OrderDetailContainer from "pages/procurement/OrderDetailContainer"
import ApprovalInboxContainer from "pages/procurement/ApprovalInboxContainer"
import OrderReviewContainer from "pages/procurement/OrderReviewContainer"
import MyOrdersContainer from "pages/procurement/MyOrdersContainer"
import MyOrderDetailContainer from "pages/procurement/MyOrderDetailContainer"
import ApprovalRulesContainer from "pages/procurement/ApprovalRulesContainer"
import ApprovalRestrictionsContainer from "pages/procurement/ApprovalRestrictionsContainer"
import ItemManagementContainer from "pages/procurement/ItemManagementContainer"
import ItemDetailContainer from "pages/procurement/ItemDetailContainer"
import ItemInventoryContainer from "pages/procurement/ItemInventoryContainer"
import BookInventoryContainer from "pages/procurement/BookInventoryContainer"
import ToPayListContainer from "pages/procurement/ToPayListContainer"
import PurchasePaymentContextContainer from "pages/procurement/PurchasePaymentContextContainer"
import CreatePaymentRequestContainer from "pages/procurement/CreatePaymentRequestContainer"
import PaymentRequestsContainer from "pages/procurement/PaymentRequestsContainer"
import PaymentRequestDetailContainer from "pages/procurement/PaymentRequestDetailContainer"
import { isProcurementV2Enabled } from "shared/procurement/featureFlags"
import { procurementNavIcons } from "components/icons/ProcurementNavIcons"

/* Admin Pages */
import { AdminTeacher } from "admin/teacher"
import { AdminAdmin } from "admin/admin"
import VersionPage from "admin/version/VersionPage"
import AdminListPage from "admin/admin/AdminListPage"
import TeacherListPage from "admin/teacher/TeacherListPage"
import LXOListPage from "admin/lxo/LXOListPage"
import LXODetailPage from "admin/lxo-detail/LXODetailPage"
import { TeacherDetail } from "admin/teacher-detail"
import { AdminNotification } from "admin/notification"
import { AdminTemplate } from "admin/templates"
import { AdminBanner } from "admin/banner"
import LXOTask from "admin/lxo-task/LXOTask"
import MyDevelopmentContainer from "./pages/my-development/MyDevelopmentContainer"
import MySelfContainer from "./pages/my-self/MySelfContainer"
import MyCalendar from "./pages/calendar/myCalendar"
import CalendarLXO from "./pages/calendar/myCalendarLXO"
import { MgrLinkContainer } from "./admin/mgr-link/MgrLinkContainer"
import { LeaveRequest } from "admin/leave-request/LeaveRequest"
import { LeaveRequestDetail } from "admin/leave-request-detail/LeaveRequestDetail"
import { LeaveRequestSetupHoliday } from "admin/leave-request-setup-holiday/LeaveRequestSetupHoliday"
import { LeaveRequestType } from "admin/leave-request-type/LeaveRequestType"
import { SVGIcon } from "./components/icons"
import { adminNavIcons } from "./components/icons/AdminNavIcons"
import { Role } from "constant/Role"

const routes = [
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "Home page",
    key: "",
    icon: <MenuHomeIcon />,
    iconActive: <MenuHomeActiveIcon />,
    noCollapse: true,
    component: <Home />,
    route: "/",
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "collapse",
    name: "My Calendar",
    key: "calendar",
    icon: <MenuCalendarIcon />,
    iconActive: <MenuCalendarActiveIcon />,
    noCollapse: true,
    component: <MyCalendar />,
    route: "/calendar",
    isPrivate: true,
    redirectPath: "/sign-in?redirectTo=calendar",
  },
  {
    type: "collapse",
    name: "My Assistant",
    key: "assistant",
    icon: <MenuAsistantIcon />,
    iconActive: <MenuAsistantActiveIcon />,
    route: "/assistant/:tab",
    hiddenInSidenav: true,
    component: <Assistant />,
    noCollapse: true,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "collapse",
    name: "My Assistant",
    key: "assistant",
    icon: <MenuAsistantIcon />,
    iconActive: <MenuAsistantActiveIcon />,
    route: "/assistant/:tab/:subTab?",
    hiddenInSidenav: true,
    component: <Assistant />,
    noCollapse: true,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  // Leave
  // {
  //   type: "collapse",
  //   name: "My Leave",
  //   key: "leave",
  //   icon: <MenuCalendarIcon />,
  //   iconActive: <MenuCalendarActiveIcon />,
  //   noCollapse: true,
  //   component: <MyCalendar />,
  //   route: "/leave",
  //   isPrivate: true,
  //   redirectPath: "/sign-in?redirectTo=calendar",
  // },

  {
    type: "collapse",
    name: "My Assistant",
    key: "assistant",
    icon: <MenuAsistantIcon />,
    iconActive: <MenuAsistantActiveIcon />,
    route: "/assistant",
    //href: "/assistant",
    component: <Assistant />,
    noCollapse: true,
    isPrivate: true,
    redirectPath: "/sign-in",
    // collapse: [
    //   {
    //     name: "My tasks",
    //     key: "my-tasks",
    //     route: "/assistant/my-tasks",
    //     component: <Assistant tab={0} />,
    //     isPrivate: true,
    //     redirectPath: "/sign-in",
    //   },
    //   {
    //     name: "My classes",
    //     key: "my-classes",
    //     route: "/assistant/my-classes",
    //     component: <Assistant tab={1} />,
    //     isPrivate: true,
    //     redirectPath: "/sign-in",
    //   },
    //   {
    //     name: "My students",
    //     key: "my-students",
    //     route: "/assistant/my-students",
    //     component: <Assistant tab={2} />,
    //     isPrivate: true,
    //     redirectPath: "/sign-in",
    //   },
    //   {
    //     name: "My EPP",
    //     key: "my-epp",
    //     route: "/assistant/my-epp",
    //     component: <Assistant tab={3} />,
    //     isPrivate: true,
    //     redirectPath: "/sign-in",
    //   },
    // ],
  },
  {
    type: "collapse",
    name: "Student Detail",
    key: "student-detail",
    noCollapse: true,
    component: <StudentDetail />,
    hiddenInSidenav: true,
    route: "/student-detail/:id",
  },
  {
    type: "collapse",
    name: "My Development",
    key: "development",
    icon: <MenuDevelopmentIcon />,
    iconActive: <MenuDevelopmentActiveIcon />,
    noCollapse: true,
    component: <MyDevelopmentContainer />,
    route: "/development",
  },
  {
    type: "collapse",
    name: "My Impact",
    key: "impact",
    icon: <MenuPerformanceIcon />,
    iconActive: <MenuPerformanceActiveIcon />,
    noCollapse: true,
    component: <MyImpact />,
    route: "/impact",
    // Hidden from the sidebar for these roles (add roles here, not in Sidenav).
    hiddenForRoles: [Role.LXO, Role.LX],
  },
  {
    type: "collapse",
    name: "Myself",
    key: "myself",
    icon: <MenuSelf />,
    iconActive: <MenuSelfActive />,
    noCollapse: true,
    component: <MySelfContainer />,
    route: "/myself",
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "collapse",
    name: "My Notification",
    key: "notification",
    icon: <MenuPerformanceIcon />,
    iconActive: <MenuPerformanceActiveIcon />,
    noCollapse: true,
    component: <Notification />,
    route: "/notification/:id",
    isPrivate: true,
    redirectPath: "/sign-in",
    hiddenInSidenav: true,
  },
]

export const adminRoutes = [
  {
    type: "collapse",
    name: "Version Page",
    key: "version-page",
    noCollapse: true,
    component: <VersionPage />,
    route: "/version",
    hiddenInSidenav: true,
  },
  {
    type: "collapse",
    name: "User Management",
    key: "user-management",
    icon: adminNavIcons.userManagement.icon,
    iconActive: adminNavIcons.userManagement.iconActive,
    noCollapse: false,
    component: <AdminListPage />,
    route: "/user-management/admin-management",
    isPrivate: true,
    redirectPath: "/sign-in",
    //hiddenInSidenav: true,
    collapse: [
      {
        type: "collapse",
        name: "Admin Managment",
        key: "admin-management",
        icon: adminNavIcons.adminManagement.icon,
        iconActive: adminNavIcons.adminManagement.iconActive,
        noCollapse: true,
        component: <AdminListPage />,
        route: "/user-management/admin-management",
        isPrivate: true,
        redirectPath: "/sign-in",
        // hiddenInSidenav: true,
      },

      {
        type: "collapse",
        name: "Teacher Management",
        key: "teacher-management",
        icon: adminNavIcons.teacherManagement.icon,
        iconActive: adminNavIcons.teacherManagement.iconActive,
        noCollapse: true,
        component: <TeacherListPage />,
        route: "/user-management/teacher-management",
        isPrivate: true,
        redirectPath: "/sign-in",
        // hiddenInSidenav: true,
      },
      {
        name: "LXO Management",
        key: "lxo-management",
        route: "/user-management/lxo-management",
        component: <LXOListPage />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
      {
        type: "hidden",
        name: "LXO Detail",
        key: "lxo-detail",
        route: "/user-management/lxo-detail/:id",
        component: <LXODetailPage />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
    ],
  },

  {
    type: "collapse",
    name: "Noti Management",
    key: "notification-management",
    icon: adminNavIcons.notificationManagement.icon,
    iconActive: adminNavIcons.notificationManagement.iconActive,
    noCollapse: false,
    component: <AdminNotification />,
    route: "notification-management",
    isPrivate: true,
    redirectPath: "/sign-in",
    // hiddenInSidenav: true,
    collapse: [
      {
        name: "Send Notification",
        key: "send-notification",
        route: "notification-management/send-notification",
        component: <AdminNotification tab={2} />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
      {
        type: "collapse",
        name: "Template Notification",
        key: "notifications-templates",
        icon: adminNavIcons.templateNotification.icon,
        iconActive: adminNavIcons.templateNotification.iconActive,
        component: <AdminTemplate />,
        route: "notification-management/notifications-templates",
        isPrivate: true,
        redirectPath: "/sign-in",
        //hiddenInSidenav: true,
      },
    ],
  },
  {
    type: "hidden",
    name: "Teacher Detail",
    key: "teacher-detail",
    icon: <MenuPerformanceIcon />,
    iconActive: <MenuPerformanceActiveIcon />,
    noCollapse: true,
    component: <TeacherDetail />,
    route: "/teacher-detail",
    isPrivate: true,
    redirectPath: "/sign-in",
    // hiddenInSidenav: true,
  },
  {
    type: "collapse",
    name: "Banner Management",
    key: "banner-management",
    icon: adminNavIcons.bannerManagement.icon,
    iconActive: adminNavIcons.bannerManagement.iconActive,
    noCollapse: true,
    component: <AdminBanner />,
    route: "/banner-management",
    isPrivate: true,
    redirectPath: "/sign-in",
    // hiddenInSidenav: true,
  },
  {
    type: "collapse",
    name: "LXO Task",
    key: "lxo-task",
    icon: adminNavIcons.lxoTask.icon,
    iconActive: adminNavIcons.lxoTask.iconActive,
    noCollapse: true,
    component: <LXOTask />,
    route: "/lxo-task",
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "collapse",
    name: "Links Manager",
    key: "links-manager",
    icon: (
      <SVGIcon name="links-manager" fill="#ADB5BD" height={32} width={32} />
    ),
    iconActive: (
      <SVGIcon name="links-manager" fill="#1576BC" height={32} width={32} />
    ),
    noCollapse: true,
    component: <MgrLinkContainer />,
    route: "/links-manager",
    isPrivate: true,
    redirectPath: "/sign-in",
    // hiddenInSidenav: true,
  },
  /* Procurement Process — ROLE_ADMIN only (gated by being in adminRoutes). */
  ...(isProcurementV2Enabled()
    ? [
        {
          type: "collapse",
          name: "Procurement Process",
          key: "procurement-process",
          icon: adminNavIcons.procurementProcess.icon,
          iconActive: adminNavIcons.procurementProcess.iconActive,
          noCollapse: false,
          component: <ApprovalRulesContainer />,
          route: "/procurement/approval-rules",
          isPrivate: true,
          redirectPath: "/sign-in",
          collapse: [
            {
              name: "Approval Rules",
              key: "approval-rules",
              component: <ApprovalRulesContainer />,
              route: "/procurement/approval-rules",
              isPrivate: true,
              redirectPath: "/sign-in",
            },
            {
              name: "Approval Restriction",
              key: "approval-restrictions",
              component: <ApprovalRestrictionsContainer />,
              route: "/procurement/approval-restrictions",
              isPrivate: true,
              redirectPath: "/sign-in",
            },
          ],
        },
      ]
    : []),
  /* Leave Request */
  // {
  //   type: "collapse",
  //   name: "Leave Request",
  //   key: "leave-request",
  //   icon: <MenuLeaveRequestIcon />,
  //   iconActive: <MenuLeaveRequestActiveIcon />,
  //   noCollapse: false,
  //   component: <LeaveRequestType />,
  //   route: "/leave-request",
  //   isPrivate: true,
  //   redirectPath: "/sign-in",
  //   collapse: [
  //     {
  //       type: "title",
  //       name: "Leave Request ",
  //       key: "setup-type",
  //       component: <LeaveRequestType />,
  //       route: "/leave-request/setup-type",
  //       isPrivate: true,
  //       redirectPath: "/sign-in",
  //     },
  //     // {
  //     //   type: "title",
  //     //   name: "Setup Holiday",
  //     //   key: "setup-holiday",
  //     //   noCollapse: true,
  //     //   component: <LeaveRequestSetupHoliday />,
  //     //   route: "/leave-request/setup-holiday",
  //     //   isPrivate: true,
  //     //   redirectPath: "/sign-in",
  //     // },
  //     {
  //       type: "hidden",
  //       name: "Leave Request Detail",
  //       key: "leave-request-detail",
  //       component: <LeaveRequestDetail />,
  //       route: "/leave-request/leave-request-detail/:id",
  //       isPrivate: true,
  //       redirectPath: "/sign-in",
  //     },
  //   ],
  // },
]

/* Now define Teacher routes and Learning Experience Officer routes*/
export const teacherRoutes = [...routes]

export const buildLxoMenu = () => [
  ...teacherRoutes.map((item) => {
    if (item.key === "calendar" && item.route === "/calendar") {
      return {
        ...item,
        name: "Calendar",
        noCollapse: false,
        collapse: [
          {
            name: "My Calendar",
            key: "my-calendar",
            route: "/calendar/my-calendar",
            isPrivate: true,
            redirectPath: "/sign-in",
            component: <MyCalendar />,
          },
          {
            name: "Teacher Calendar",
            key: "teacher-calendar",
            route: "/calendar/teacher-calendar",
            isPrivate: true,
            redirectPath: "/sign-in",
            component: <CalendarLXO />,
          },
          {
            name: "Center Calendar",
            key: "center-calendar",
            route: "/calendar/center-calendar",
            isPrivate: true,
            redirectPath: "/sign-in",
            component: <Calendar />,
          },
        ],
      }
    }
    if (item.key === "assistant" && item.route === "/assistant") {
      return {
        ...item,
        noCollapse: false,
        collapse: [
          {
            name: "My tasks",
            key: "my-tasks",
            route: "/assistant/my-tasks",
            isPrivate: true,
            redirectPath: "/sign-in",
          },
          {
            name: "Class Situation",
            key: "class-situation",
            route: "/assistant/class-situation",
            isPrivate: true,
            redirectPath: "/sign-in",
          },

          {
            name: "Teacher Management",
            key: "teacher-management",
            route: "/assistant/teacher-management/information",
            isPrivate: true,
            redirectPath: "/sign-in",
            // collapse: [
            //   {
            //     name: "Teacher Information",
            //     key: "teacher-information",
            //     route: "/assistant/teacher-management/information",
            //     isPrivate: true,
            //     redirectPath: "/sign-in",
            //   },
            //   {
            //     name: "Leave",
            //     key: "leave",
            //     route: "/assistant/teacher-management/leave",
            //     isPrivate: true,
            //     redirectPath: "/sign-in",
            //   },
            //   {
            //     name: "Timesheet",
            //     key: "timesheet",
            //     route: "/assistant/teacher-management/timesheet",
            //     isPrivate: true,
            //     redirectPath: "/sign-in",
            //   },
            //   {
            //     name: "Teacher Performance",
            //     key: "teacher-performance",
            //     route: "/assistant/teacher-management/performance",
            //     isPrivate: true,
            //     redirectPath: "/sign-in",
            //   },
            //   {
            //     name: "Teacher change",
            //     key: "teacher-change",
            //     route: "/assistant/teacher-management/change",
            //     isPrivate: true,
            //     redirectPath: "/sign-in",
            //   },
            // ],
          },
        ],
      }
    }
    // else if (item.key === "assitant" && item.route === "/assistant/:tab") {
    //   return {
    //     type: "collapse",
    //     name: "Assistant Dynamic",
    //     key: "assistant-dynamic",
    //     route: "/assistant/:tab/*",
    //     component: <Assistant />,
    //     isPrivate: true,
    //     redirectPath: "/sign-in",
    //     hiddenInSidenav: true,
    //   };
    // }

    return item
  }),
  {
    type: "collapse",
    name: "Leave Request",
    key: "leave-request",
    icon: <MenuLeaveRequestIcon />,
    iconActive: <MenuLeaveRequestActiveIcon />,
    noCollapse: false,
    component: <LeaveRequestType />,
    route: "/leave-request",
    isPrivate: true,
    redirectPath: "/sign-in",
    collapse: [
      {
        type: "title",
        name: "Leave Request ",
        key: "list",
        component: <LeaveRequestType />,
        route: "/leave-request/list",
        isPrivate: true,
        redirectPath: "/sign-in",
      },
      {
        type: "hidden",
        name: "Leave Request Detail",
        key: "leave-request-detail",
        component: <LeaveRequestDetail />,
        route: "/leave-request/leave-request-detail/:id",
        isPrivate: true,
        redirectPath: "/sign-in",
      },
    ],
  },
]

// Back-compat: a concrete LXO menu array built from the factory above.
// The LX menu (and future role clones) live in their own modules under src/menus/.
export const lxoRoutes = buildLxoMenu()

// Legacy requester menu (Purchase Requisition + Budget Overview). Kept as a
// fallback when the V2 feature flag is disabled, so nothing breaks if turned off.
export const procurementRouteLegacy = {
  type: "collapse",
  name: "Procurement",
  key: "procurement",
  icon: <MenuPerformanceIcon />,
  iconActive: <MenuPerformanceActiveIcon />,
  noCollapse: false,
  route: "/procurement/requests",
  component: <PurchaseRequisitionContainer />,
  isPrivate: true,
  redirectPath: "/sign-in",
  collapse: [
    {
      name: "Purchase Requisition",
      key: "procurement-requests",
      route: "/procurement/requests",
      component: <PurchaseRequisitionContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      name: "Budget Overview",
      key: "procurement-budget",
      route: "/procurement/budget",
      component: <BudgetOverviewContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Create Purchase Request",
      key: "procurement-requests-new",
      route: "/procurement/requests/new",
      component: <CreateRequestContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Purchase Request Detail",
      key: "procurement-requests-detail",
      route: "/procurement/requests/:id",
      component: <RequestDetailContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
  ],
}

// V2 requester menu (ROLE_REQUESTER): Budget · Order Request · My Orders.
const procurementRouteV2 = {
  type: "collapse",
  name: "Procurement",
  key: "procurement",
  icon: <MenuPerformanceIcon />,
  iconActive: <MenuPerformanceActiveIcon />,
  noCollapse: false,
  // Sidenav wraps a `type: "collapse"` top-level item in a <NavLink to={route}>
  // (see Sidenav/index.js's renderRoutes), so clicking the "Procurement" label
  // itself — not just a submenu row — navigates here. Bound to My Orders
  // rather than Budget: this tree (procurementRoute) is only reached via
  // PROCUREMENT_MENU_ACCESS's "v2" tree, which today is LXO-only, and LXO has
  // no Budget access at all (see menuAccess.js) — landing on Budget would
  // leak a page that isn't even in their filtered collapse.
  route: "/procurement/my-orders",
  component: <MyOrdersContainer />,
  isPrivate: true,
  redirectPath: "/sign-in",
  collapse: [
    {
      name: "Budget",
      key: "procurement-budget",
      route: "/procurement/budget",
      component: <BudgetOverviewContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    // Every procurement-eligible role (Requester included) — the user's own
    // order requests (GET .../order-requests/my-orders).
    {
      name: "My Orders",
      key: "procurement-my-orders",
      route: "/procurement/my-orders",
      component: <MyOrdersContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    // ROLE_PROCUREMENT only (filtered out for other procurement-eligible
    // roles — see PROCUREMENT_ONLY_KEYS). Org-wide order list (GET
    // .../order-requests) — procurement staff monitor every order, not just
    // their own.
    {
      name: "Order",
      key: "procurement-orders",
      route: "/procurement/orders",
      component: <OrdersContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    // ROLE_PROCUREMENT only (filtered out for other procurement-eligible
    // roles — see PROCUREMENT_ONLY_KEYS). Some approval-rule steps name
    // ROLE_PROCUREMENT itself as the approver (not just the Manager role), so
    // plain Procurement staff need somewhere to act on those too — same GET
    // .../order-requests/for-approval the Manager inbox uses, already scoped
    // server-side to "am I the current-step approver".
    {
      name: "Approve Order",
      key: "procurement-approvals",
      route: "/procurement/approvals",
      component: <ApprovalInboxContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Order Approval Detail",
      key: "procurement-approvals-order-detail",
      route: "/procurement/orders/:id",
      component: <OrderReviewContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      // Kept mounted (bookmarks / in-app links) but no longer in the sidenav —
      // "My Orders" and "Order" cover the two list views now.
      type: "hidden",
      name: "Order Requests",
      key: "procurement-order-requests",
      route: "/procurement/order-requests",
      component: <OrderRequestContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    // ROLE_PROCUREMENT only (filtered out for other procurement-eligible
    // roles in App.js — see PROCUREMENT_ONLY_KEYS).
    {
      name: "Purchase",
      key: "procurement-requests",
      route: "/procurement/purchase-requests",
      component: <PurchasesContainer standalone title="Purchase" breadcrumb="Procurement" />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      name: "Payment",
      key: "procurement-payment-requests",
      route: "/procurement/payment-requests",
      component: <PaymentRequestsContainer standalone centerScoped title="Payment" breadcrumb="Procurement" />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    // Department managers only (DEPARTMENT_MANAGER_ACCESS).
    {
      name: "Approve Purchase",
      key: "procurement-approve-purchases",
      route: "/procurement/purchases/approvals",
      component: <PurchasesContainer approvalOnly />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      name: "Approve Payment Request",
      key: "procurement-approve-payment-requests",
      route: "/procurement/payment-requests/approvals",
      component: <PaymentRequestsContainer approvalOnly />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "To Pay",
      key: "procurement-to-pay",
      route: "/procurement/to-pay",
      component: <ToPayListContainer standalone breadcrumb="Procurement" />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Purchase Payment Context",
      key: "procurement-to-pay-detail",
      route: "/procurement/to-pay/:id",
      component: <PurchasePaymentContextContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Create Payment Request",
      key: "procurement-payment-requests-new",
      route: "/procurement/payment-requests/new",
      component: <CreatePaymentRequestContainer centerScoped />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Edit Payment Request",
      key: "procurement-payment-requests-edit",
      route: "/procurement/payment-requests/:id/edit",
      component: <CreatePaymentRequestContainer centerScoped />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Payment Request Detail",
      key: "procurement-payment-requests-detail",
      route: "/procurement/payment-requests/:id",
      component: <PaymentRequestDetailContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      // "View" on the Purchase Requests list opens the same PO detail page the
      // Manager workspace uses (pm-purchases-detail) — this route was missing
      // here, so the requester-side list navigated to an unregistered path.
      type: "hidden",
      name: "PO Detail",
      key: "procurement-purchases-detail",
      route: "/procurement/purchases/:id",
      component: <PurchaseDetailContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Create PO",
      key: "procurement-purchases-new",
      route: "/procurement/purchases/new",
      component: <CreatePurchaseContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Edit PO",
      key: "procurement-purchases-edit",
      route: "/procurement/purchases/:id/edit",
      component: <CreatePurchaseContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "New Order Request",
      key: "procurement-order-new",
      route: "/procurement/order-requests/new",
      component: <OrderRequestFormContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "New Group Order",
      key: "procurement-group-order-new",
      route: "/procurement/order-requests/group/new",
      component: <GroupOrderFormContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Edit Order Request",
      key: "procurement-order-edit",
      route: "/procurement/order-requests/:id/edit",
      component: <OrderRequestFormContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      // A focused view of just the Vendor Proposals panel for one order —
      // linked from the order list drawer / detail page, so staff don't have
      // to open the full edit form just to invite a supplier or check quotes.
      type: "hidden",
      name: "Order Vendor Proposals",
      key: "procurement-order-vendor-proposals",
      route: "/procurement/order-requests/:id/vendor-proposals",
      component: <VendorProposalsPageContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Order Request Detail",
      key: "procurement-order-detail",
      route: "/procurement/order-requests/:id",
      component: <OrderDetailContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "My Order Tracking",
      key: "procurement-my-order-detail",
      route: "/procurement/my-orders/:id",
      component: <MyOrderDetailContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Create Purchase Request",
      key: "procurement-requests-new",
      route: "/procurement/requests/new",
      component: <CreateRequestContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
    {
      type: "hidden",
      name: "Purchase Request Detail",
      key: "procurement-requests-detail",
      route: "/procurement/requests/:id",
      component: <RequestDetailContainer />,
      isPrivate: true,
      redirectPath: "/sign-in",
    },
  ],
}

export const procurementRoute = isProcurementV2Enabled()
  ? procurementRouteV2
  : procurementRouteLegacy

export const procurementManagerRoutes = [
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "Budget Control",
    key: "pm-budget",
    route: "/procurement/budget",
    component: <BudgetOverviewContainer oversight />,
    icon: procurementNavIcons.budget.icon,
    iconActive: procurementNavIcons.budget.iconActive,
    noCollapse: true,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  // Order / Purchase / Payment used to each get their own top-level sidebar
  // entries (9 of them) — grouped into 3 expandable parents so the manager
  // sidebar isn't a wall of items. Routing is unaffected: App.js's getRoutes
  // recurses into `collapse` regardless of nesting, so every child route
  // below still registers exactly as before.
  {
    type: "collapse",
    name: "Order",
    key: "pm-order-group",
    route: "/procurement/orders",
    component: <OrdersContainer />,
    icon: procurementNavIcons.orders.icon,
    iconActive: procurementNavIcons.orders.iconActive,
    noCollapse: false,
    isPrivate: true,
    redirectPath: "/sign-in",
    collapse: [
      {
        name: "My Orders",
        key: "pm-my-orders",
        route: "/procurement/my-orders",
        component: <MyOrdersContainer />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
      {
        name: "Orders (OR)",
        key: "pm-orders",
        route: "/procurement/orders",
        component: <OrdersContainer />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
      {
        name: "Group Orders",
        key: "pm-group-orders",
        route: "/procurement/orders/groups",
        component: <OrdersContainer groupOnly />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
      {
        name: "Approve Order",
        key: "pm-approvals",
        route: "/procurement/approvals",
        component: <ApprovalInboxContainer />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
    ],
  },
  {
    type: "collapse",
    name: "Purchases",
    key: "pm-purchase-group",
    route: "/procurement/purchases",
    component: <PurchasesContainer />,
    icon: procurementNavIcons.orders.icon,
    iconActive: procurementNavIcons.orders.iconActive,
    noCollapse: false,
    isPrivate: true,
    redirectPath: "/sign-in",
    collapse: [
      {
        name: "Purchases (PO)",
        key: "pm-purchases",
        route: "/procurement/purchases",
        component: <PurchasesContainer />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
      {
        name: "Approve Purchase",
        key: "pm-approve-purchases",
        route: "/procurement/purchases/approvals",
        component: <PurchasesContainer approvalOnly />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
    ],
  },
  {
    type: "collapse",
    name: "Payment",
    key: "pm-payment-group",
    route: "/procurement/to-pay",
    component: <ToPayListContainer />,
    icon: procurementNavIcons.requests.icon,
    iconActive: procurementNavIcons.requests.iconActive,
    noCollapse: false,
    isPrivate: true,
    redirectPath: "/sign-in",
    collapse: [
      {
        name: "To Pay",
        key: "pm-to-pay",
        route: "/procurement/to-pay",
        component: <ToPayListContainer />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
      {
        name: "Payment Requests",
        key: "pm-payment-requests",
        route: "/procurement/payment-requests",
        component: <PaymentRequestsContainer />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
      {
        // GET /payment-requests?awaiting_me=true — current-step approver
        // only (escalation/delegation-aware), distinct from ?status=pending
        // which returns every approver's pending PRs.
        name: "Approve Payment Request",
        key: "pm-approve-payment-requests",
        route: "/procurement/payment-requests/approvals",
        component: <PaymentRequestsContainer approvalOnly />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
    ],
  },
  {
    type: "hidden",
    name: "My Order Tracking",
    key: "pm-my-order-detail",
    route: "/procurement/my-orders/:id",
    component: <MyOrderDetailContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "New Order Request",
    key: "pm-order-new",
    route: "/procurement/order-requests/new",
    component: <OrderRequestFormContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  // Both order forms navigate here after a successful save (see
  // OrderRequestFormContainer / GroupOrderFormContainer), but this path only
  // existed on the V2 tree — so saving an order from the manager tree
  // dead-ended. Mirrors the V2 `procurement-order-requests` entry.
  {
    type: "hidden",
    name: "Order Requests",
    key: "pm-order-requests",
    route: "/procurement/order-requests",
    component: <OrderRequestContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Edit Order Request",
    key: "pm-order-edit",
    route: "/procurement/order-requests/:id/edit",
    component: <OrderRequestFormContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Order Vendor Proposals",
    key: "pm-order-vendor-proposals",
    route: "/procurement/order-requests/:id/vendor-proposals",
    component: <VendorProposalsPageContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "New Group Order",
    key: "pm-group-order-new",
    route: "/procurement/order-requests/group/new",
    component: <GroupOrderFormContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Purchase Payment Context",
    key: "pm-to-pay-detail",
    route: "/procurement/to-pay/:id",
    component: <PurchasePaymentContextContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Create Payment Request",
    key: "pm-payment-requests-new",
    route: "/procurement/payment-requests/new",
    component: <CreatePaymentRequestContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Edit Payment Request",
    key: "pm-payment-requests-edit",
    route: "/procurement/payment-requests/:id/edit",
    component: <CreatePaymentRequestContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Payment Request Detail",
    key: "pm-payment-requests-detail",
    route: "/procurement/payment-requests/:id",
    component: <PaymentRequestDetailContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "collapse",
    name: "Reports",
    key: "pm-report",
    route: "/procurement/report",
    component: <ReportContainer />,
    icon: procurementNavIcons.report.icon,
    iconActive: procurementNavIcons.report.iconActive,
    noCollapse: true,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "collapse",
    name: "Reports",
    key: "pm-budget-report",
    route: "/procurement/budget-report",
    component: <BudgetReportContainer />,
    icon: procurementNavIcons.report.icon,
    iconActive: procurementNavIcons.report.iconActive,
    noCollapse: true,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "collapse",
    name: "Suppliers",
    key: "pm-suppliers",
    route: "/procurement/suppliers",
    component: <SuppliersContainer />,
    icon: procurementNavIcons.suppliers.icon,
    iconActive: procurementNavIcons.suppliers.iconActive,
    noCollapse: true,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "collapse",
    name: "Items",
    key: "pm-items",
    route: "/procurement/items",
    component: <ItemManagementContainer />,
    icon: procurementNavIcons.items.icon,
    iconActive: procurementNavIcons.items.iconActive,
    noCollapse: true,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "collapse",
    name: "Book Inventory",
    key: "pm-book-inventory",
    route: "/procurement/book-inventory",
    component: <BookInventoryContainer />,
    icon: procurementNavIcons.books.icon,
    iconActive: procurementNavIcons.books.iconActive,
    noCollapse: true,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    // Old nested URL. Book Inventory is now its own menu; this stays routable
    // so existing links land on the new page instead of a dead stock tab.
    type: "hidden",
    name: "Item inventory",
    key: "pm-item-inventory",
    route: "/procurement/items/inventory",
    component: <ItemInventoryContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "New Item",
    key: "pm-items-new",
    route: "/procurement/items/new",
    component: <ItemDetailContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Item Detail",
    key: "pm-items-detail",
    route: "/procurement/items/:id",
    component: <ItemDetailContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Create PO",
    key: "pm-purchases-new",
    route: "/procurement/purchases/new",
    component: <CreatePurchaseContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "PO Detail",
    key: "pm-purchases-detail",
    route: "/procurement/purchases/:id",
    component: <PurchaseDetailContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Edit PO",
    key: "pm-purchases-edit",
    route: "/procurement/purchases/:id/edit",
    component: <CreatePurchaseContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Supplier Detail",
    key: "pm-supplier-detail",
    route: "/procurement/suppliers/:id",
    component: <SupplierDetailContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Group Order Detail",
    key: "pm-group-order-detail",
    route: "/procurement/orders/groups/:id",
    component: <GroupOrderDetailContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Group Order Vendor Proposals",
    key: "pm-group-order-vendor-proposals",
    route: "/procurement/orders/groups/:id/vendor-proposals",
    component: <VendorProposalsPageContainer group />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Order Detail",
    key: "pm-order-detail",
    route: "/procurement/orders/:id",
    component: <OrderReviewContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Create Purchase Request",
    key: "pm-requests-new",
    route: "/procurement/requests/new",
    component: <CreateRequestContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "hidden",
    name: "Purchase Request Detail",
    key: "pm-requests-detail",
    route: "/procurement/requests/:id",
    component: <RequestDetailContainer manager />,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
]

// Any role whose code contains "MANAGER" (department heads, center managers —
// see isManagerRole in shared/procurement/eligibleRoles.js) gets a
// "Procurement" group appended to their own menu — same grouped-collapse
// shape as the LXO/Requester "Procurement" entry (procurementRouteV2) above,
// just scoped to Order approval instead of the full Procurement Manager
// workspace (Budget/Suppliers/Purchases/Payments stay out — they aren't
// procurement staff, just occasional approvers on an approval-rule step).
// Appended in App.js next to the existing Requester-menu append.
export const managerOrderApprovalRoutes = [
  {
    type: "collapse",
    name: "Procurement",
    key: "mgr-procurement",
    icon: <MenuPerformanceIcon />,
    iconActive: <MenuPerformanceActiveIcon />,
    noCollapse: false,
    route: "/procurement/approvals",
    component: <ApprovalInboxContainer />,
    isPrivate: true,
    redirectPath: "/sign-in",
    collapse: [
      {
        name: "Approve Order",
        key: "mgr-approvals",
        route: "/procurement/approvals",
        component: <ApprovalInboxContainer />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
      {
        type: "hidden",
        name: "Order Detail",
        key: "mgr-order-detail",
        route: "/procurement/orders/:id",
        component: <OrderReviewContainer />,
        isPrivate: true,
        redirectPath: "/sign-in",
      },
    ],
  },
]

export const commonRoutes = [
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    noCollapse: true,
    component: <SignIn />,
    route: "/sign-in",
    hiddenInSidenav: true,
  },
  {
    type: "collapse",
    name: "Change Password",
    key: "change-password",
    noCollapse: true,
    component: <ChangePassword />,
    route: "/change-password",
    hiddenInSidenav: true,
    isPrivate: true,
    redirectPath: "/sign-in",
  },
  {
    type: "collapse",
    name: "Reset Password Validate",
    key: "reset-password-validate",
    noCollapse: true,
    component: <ResetPasswordValidate />,
    route: "/reset-password-validate",
    hiddenInSidenav: true,
  },
  {
    type: "collapse",
    name: "Reset Password",
    key: "reset-password",
    noCollapse: true,
    component: <ResetPassword />,
    route: "/reset-password",
    hiddenInSidenav: true,
  },
  {
    type: "collapse",
    name: "Google Success",
    key: "google-success",
    noCollapse: true,
    component: <GoogleSuccess />,
    route: "/google-success",
    hiddenInSidenav: true,
  },
  {
    type: "collapse",
    name: "Google Fail",
    key: "google-fail",
    noCollapse: true,
    component: <GoogleFail />,
    route: "/google-fail",
    hiddenInSidenav: true,
  },
  {
    type: "collapse",
    name: "Vendor Proposal Submit",
    key: "vendor-proposal-submit",
    noCollapse: true,
    component: <VendorProposalSubmit />,
    route: "/procurement/vendor-proposal",
    hiddenInSidenav: true,
  },
]

export default routes
